import React from 'react';
import './Sidebar.css';
import logo from '../images/ensenartecorto.png'; // larger logo used when sidebar expanded
import smallLogo from '../images/logo512.png'; // 512x512 logo for collapsed state (public folder)  

function Sidebar({ userEmail, userRole, onLogout, isOpen, toggleSidebar, onNavigate, activeView, sectionsAccess }) {
  const allSections = [
    { key: 'dashboard', label: 'DASHBOARD', icon: '📊' },
    { key: 'add', label: 'AGREGAR ESTUDIANTE', icon: '🧑‍🎓' },
    { key: 'courses', label: 'MIS CURSOS', icon: '📚' },
    { key: 'programas', label: 'PROGRAMAS', icon: '⚙️' },
    { key: 'icfes', label: 'ICFES', icon: '🧠' },
    { key: 'financiamiento', label: 'FINANCIAMIENTO', icon: '💰' },
    { key: 'estudiantes', label: 'ESTUDIANTES', icon: '👨‍🎓' },
    { key: 'interesados', label: 'INTERESADOS', icon: '👥' },
    { key: 'permisos', label: 'PERMISOS', icon: '🔐' },
  ];

  const normalizedAccess = (sectionsAccess || []).map(access => access?.toString().trim().toUpperCase());
  const visibleSections = allSections.filter(section =>
    normalizedAccess.includes(section.label.toUpperCase()) ||
    userRole === 'ADMINISTRADORES'
  );

  return (
    <aside className={`csb-container ${isOpen ? 'csb-open' : 'csb-closed'}`}>
      {/* HEADER */}
      <div className="csb-header">
        {/* logo replaces toggle button; clicking it toggles sidebar */}
        <img
          src={isOpen ? logo : smallLogo}
          alt="Logo"
          className="csb-logo csb-toggle-logo"
          onClick={toggleSidebar}
          style={{ cursor: 'pointer' }}
        />
      </div>

      {/* NAV */}
      <nav className="csb-nav" aria-label="Main navigation">
        {visibleSections.map(section => (
          <button
            key={section.key}
            type="button"
            className={`csb-nav-item ${activeView === section.key ? 'csb-active' : ''}`}
            onClick={() => onNavigate(section.key)}
          >
            <span className="csb-nav-icon">{section.icon}</span>
            {isOpen && <span className="csb-nav-label">{section.label}</span>}
          </button>
        ))}
      </nav>

      {/* FOOTER */}
      <div className="csb-footer">
        {isOpen && (
          <div className="csb-user-info">
            <p className="csb-user-name">{userRole || 'USUARIO'}</p>
          </div>
        )}

        <button className="csb-logout-btn" onClick={onLogout}>
          <span className="csb-nav-icon">🚪</span>
          {isOpen && <span className="csb-nav-label">CERRAR SESIÓN</span>}
        </button>
      </div>

    </aside>
  );
}

export default Sidebar;